import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Moment from "react-moment";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import moment from "moment";

import MyButton from "./MyButton";

const styles = {
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  formControl: {
    marginTop: 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: 1,
  },
  paper: {},
  textField: {
    marginLeft: 1,
    marginRight: 1,
    width: 250,
  },
};
const columns = [
  { field: "id", headerName: "STT", width: 70 },
  {
    field: "ThoiGian",
    headerName: "Thời gian",
    width: 130,
    renderCell: (params) => (
      <Moment format="DD-MM-yyyy">{params.getValue("ThoiGian")}</Moment>
    ),
  },
  { field: "lat", headerName: "VĐ", width: 70 },
  { field: "lon", headerName: "KĐ", width: 70 },
];

class SuKienPhuongTienDialog extends React.Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.state = {
      open: props.visible,
      fullWidth: true,
      maxWidth: "sm",
      sukien: {
        nguontin: "HCM RADIO",
      }, //thong tin ve su kien
      dataRows: [],
    };
  }
  render() {
    return <div>Hello</div>;
  }
  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };
  static getDerivedStateFromProps(props, state) {
    return { ...state };
  }
  render() {
    return (
      <React.Fragment>
        <Dialog
          fullWidth={this.props.fullWidth}
          maxWidth={this.props.maxWidth}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="max-width-dialog-title">Cập nhật sự vụ - Điều động phương tiện</DialogTitle>
          <DialogContent>
            <form style={styles.form} noValidate autoComplete="off">
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Tên sự vụ:" />
                </Grid>
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Số hồ sơ:" />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="datetime-local"
                    label="Thời gian điều động:"
                    type="datetime-local"
                    defaultValue="2017-05-24T10:30"
                    format="DD-MM-YYYY"
                    style={styles.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Tàu SAR:" value="SAR 1, SAR 2" />
                </Grid>                   
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Tàu khác:" />
                </Grid>                   
                <Grid item xs={6}>
                  <FormControl style={styles.formControl}>
                    <InputLabel id="demo-simple-select-label">
                      Loại tàu:
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={this.state.sukien.nguontin}
                    >
                      <MenuItem value={"HCM RADIO"}>Tàu dầu</MenuItem>
                      <MenuItem value={"VUNG TAU RADIO"}>Tàu hàng</MenuItem>
                      <MenuItem value={"KHAC"}>Tàu cá</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>                
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Trọng tải:" />
                </Grid>                   
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Công suất:" />
                </Grid>                   
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Mô tả phương tiện:" />
                </Grid>                   
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Ghi chú:" />
                </Grid>                   
                <Grid item xs={6}>
                  <TextField
                    id="datetime-local"
                    label="Thời gian xuất bến:"
                    type="datetime-local"
                    defaultValue="2017-05-24T10:30"
                    format="DD-MM-YYYY"
                    style={styles.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>                            
                <Grid item xs={6}>
                  <TextField
                    id="datetime-local"
                    label="Thời gian kết thúc:"
                    type="datetime-local"
                    defaultValue="2017-05-24T10:30"
                    format="DD-MM-YYYY"
                    style={styles.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Vị trí (VĐ):" />
                </Grid>                   
                <Grid item xs={6}>
                  <TextField id="txtTentau" label="Vị trí (KĐ):" />
                </Grid>                                   
                <Grid item xs={6}>
                  <TextField
                    id="datetime-local"
                    label="Thời gian vị trí:"
                    type="datetime-local"
                    defaultValue="2017-05-24T10:30"
                    format="DD-MM-YYYY"
                    style={styles.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <MyButton onClick={this.handleClose} color="primary" text="Cập nhật" />  
                </Grid>
                <Grid item xs={12}>
                <label>Lịch sử vị trí:</label>
                <div style={{ height: 200, width: "100%" }}>
                  <DataGrid
                    rows={this.state.dataRows}
                    columns={columns}
                    id="MaSK"
                    hideFooterPagination={true}
                  />
                </div>
                </Grid>
              </Grid>
            </form>
          </DialogContent>
          <DialogActions>
            <MyButton onClick={this.handleClose} color="primary" text="Lưu" />
            <MyButton onClick={this.handleClose} color="primary" text="Thoát" />
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default SuKienPhuongTienDialog;
